export const errorMessageStatusOrErrorsIsIncorrect =
  'status incorrect or errors is undefined, check action name in query/mutation hook';
